import { IconButton as MUIIconButton, styled } from "@mui/material"

export const IconButton = styled(MUIIconButton)(({ theme, color }) => ({
  color: color || 'white',
  ...(!color && {
    backgroundColor: theme.palette.primary.main,
    ':hover': {
      backgroundColor: theme.palette.primary.light
    }
  })
}))